
<div>
  <product-category-assignment v-for="category_assignment in category_assignments" :key="category_assignment.id"
                               :category-assignment="category_assignment"
                               :is-public="isPublic">
  </product-category-assignment>
</div>
